<template>
    <div>
        <div class="search">
            <my-search timeScreen :order="1" :searchParams="searchParams" :selectArr="selectArr" @searchEvent="searchEvent" />

            <el-button type="primary" icon="el-icon-plus" circle class="addBtn" @click="addChannel"></el-button>
        </div>
        <!-- 表格展示查询的数据  -->
        <myTable :loading="loading" :tableData="tableData" :tableHeader="tableHeader">
            <template v-slot:table_after>
                <!-- <el-table-column label="状态" align="center" prop="status">
                    <template slot-scope="scope">
                        <span class="length-block">
                            {{ scope.row.status | formatStatus }}
                        </span>
                    </template></el-table-column
                > -->
                <el-table-column label="创建时间" align="center" prop="createTime"></el-table-column>
                <el-table-column label="操作" min-width="200px" align="center">
                    <template slot-scope="{ row }">
                        <!-- <el-button
                            type="text"
                            size="mini"
                            @click="operateChannel(row)"
                            >{{
                                ["0", "2"].includes(row.status)
                                    ? "审核"
                                    : row.status == "3"
                                    ? "关闭"
                                    : "开启"
                            }}</el-button
                        > -->
                        <el-button type="text" size="mini" @click="editItem(row)">编辑</el-button>
                        <el-button type="text" size="mini" @click="deleteitem(row)">删除</el-button>
                    </template>
                </el-table-column>
            </template>
        </myTable>
        <!-- 分页器 -->
        <my-pagination :childMsg="pageParams" @callFather="callFather" />
        <!-- 添加、修改组件             :selectArrAdd="selectArrAdd" -->
        <my-dialog :isDialogShow.sync="isDialogShow" :operTitle="operTitle" :operForm="operForm" :rules="rules" @submitForm="submitForm">
            <!-- 上传图片和关键字选择 -->
            <template v-slot:upload>
                <el-form-item label="频道" prop="channelId">
                    <el-select clearable value-key="id" size="mini" v-model="operForm.channelId" placeholder="请选择频道" @change="getCurrent">
                        <el-option v-for="item1 in channelList" :key="item1.id" :label="item1.name" :value="item1">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="operTitle" label="文章" prop="docIdList">
                    <el-select size="mini" v-model="operForm.docIdList" multiple placeholder="请选择文章" clearable>
                        <el-option v-for="item in docList" :key="item.id" :label="item.docTitle" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </template>
        </my-dialog>
    </div>
</template>

<script>
import {
    delChannelResource,
    updateChannelResource,
    doclist,
    addResource,
    unitList,
    resourcesList,
    channelList,
} from "@/network/content/channel.js";
import mixins from "@/mixins/common";
export default {
    name: "resources",
    mixins: [mixins],
    data() {
        return {
            tableHeader: Object.freeze([
                {
                    name: "标题",
                    prop: "docTitle",
                },
                {
                    name: "来源",
                    prop: "createUnit",
                },
                {
                    name: "发布时间",
                    prop: "startTime",
                },
                // {
                //     name: "频道id",
                //     prop: "channelId",
                // },
                // {
                //     name: "创建时间",
                //     prop: "createTime",
                // },
            ]),
            selectArr: [
                {
                    defaultText: "请选择归属频道",
                    name: "channelId",
                    getData: "id",
                    label: "name",
                    defaultOptions: [],
                },
                {
                    defaultText: "请选择来源企业",
                    name: "unitId",
                    getData: "id",
                    label: "shortName",
                    defaultOptions: [],
                },
            ],
            searchParams: {
                channelId: "",
                unitId: "",
                timeOptions: [],
            },
            //添加、编辑时文本框所需参数
            // selectArrAdd: [
            //     {
            //         name: "name", //展示
            //         label: "归属频道",
            //         value: "channelId",
            //         getData: "id",
            //         getCurrent(val) {
            //             console.log(val);
            //         },
            //         defaultOptions: [],
            //     },
            // ],
            channelList: [],
            //添加、编辑双向绑定值
            operForm: {
                docIdList: [],
                channelId: "",
            },
            // 弹出框的表单验证
            rules: {
                channelId: [
                    {
                        required: true,
                        message: "请输入归属频道",
                        trigger: "blur",
                    },
                ],
                docIdList: [
                    {
                        required: true,
                        message: "请输入文章",
                        trigger: "blur",
                    },
                ],
            },
            docParams: { channelId: "" },
            docList: [],
        };
    },
    // filters: {
    //     formatStatus(status) {
    //         let statusArray = ["待审核", "正常", "失败", "关闭"];
    //         return statusArray[status];
    //     },
    // },
    methods: {
        getCurrent(val) {
            if (this.docParams.channelId != val.channelId) {
                this.operForm.docIdList = [];
                this.docParams = { unitId: val.unitId, channelId: val.id };
                this.getDocList(this.docParams);
            }
        },
        getInitData(currentPage = this.pageParams.currentPage) {
            let { timeOptions, channelId, unitId } = this.searchParams;
            let params = {
                data: {
                    channelId,
                    unitId,
                    startTime: timeOptions ? timeOptions[0] : "",
                    endTime: timeOptions ? timeOptions[1] : "",
                },
                current: currentPage,
                size: this.pageParams.pageSize,
            };
            resourcesList(params).then((e) => {
                this.loading = true;
                let { code, data } = e.data;
                if (code == 200) {
                    this.loading = false;
                    this.tableData = data.records;
                    this.pageParams.total = data.total;
                    // this.pageParams.currentPage = currentPage;
                }
            });
        },
        getUnitList() {
            unitList().then((e) => {
                let { code, data } = e.data;
                if (code == 200) {
                    this.selectArr[1].defaultOptions = data;
                    // this.channelList = data;
                }
            });
        },
        getChannelList() {
            channelList({ data: { status: "" }, current: 1, size: 1000 }).then(
                (e) => {
                    let { code, data } = e.data;
                    if (code == 200) {
                        this.selectArr[0].defaultOptions = data.records;
                        this.channelList = data.records;
                    }
                }
            );
        },
        getDocList(params = {}) {
            doclist(params).then((res) => {
                let { code, data } = res.data;
                if (code == 200) {
                    // this.selectArr[1].defaultOptions = data;
                    this.docList = data;
                }
            });
        },
        // 搜索
        searchEvent() {
            this.getInitData(1);
        },
        //  添加频道
        addChannel() {
            // 清空
            this.operForm = {};
            this.operTitle = true;
            this.isDialogShow = true;
        },
        editItem(row) {
            this.operForm = {
                id: row.id,
                docId: row.docId, //文章不修改
                docIdList: [],
                channelId: { id: row.channelId },
            };
            this.operTitle = false;
            this.isDialogShow = true;
        },
        //提交表单
        async submitForm({ valid, operTitle }) {
            // operTitle ture添加  否则是编辑
            if (valid) {
                let param = {
                    ...this.operForm,
                    channelId: this.operForm.channelId.id,
                };
                let api = operTitle ? addResource : updateChannelResource;
                let { data } = await api(param);
                if (data.code == 200) {
                    this.isDialogShow = false;
                    this.$message.success("操作成功");
                    this.getInitData();
                }
            }
        },
        // 删除
        deleteitem(row) {
            this.$confirm("删除该条数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    let { data } = await delChannelResource({ id: row.id });
                    if (data.code == 200) {
                        this.$message.success("删除成功");
                        this.getInitData();
                    }
                })
                .catch(() => { });
        },
        //添加
        // 操作
        operateChannel(row) {
            const params = {
                id: row.id,
                isClose: row.status == 3 ? 1 : 3,
            };
            operateChannel(params)
                .then((res) => {
                    if (res.data.code == 200) {
                        this.$message.success("操作成功");
                    }
                })
                .catch(() => { });
        },
    },
    created() {
        this.getChannelList(); // 频道列表
        this.getUnitList(); // 频道列表
    },
};
</script>

<style lang="scss" scoped>
.search {
    // height: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.addBtn {
    margin: 0 0 10px 20px;
}
.el-select {
    width: 100%;
}

::v-deep .el-select {
    width: 100%;
    .el-select__tags {
        white-space: nowrap;
        overflow: hidden;
        flex-wrap: nowrap;
        .el-select__tags-text {
            display: inline-block;
            // max-width: var(--tagsWidth);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}
</style>